export default store => {
    // called when the store is initialized
    store.subscribe((mutation, state) => {
        /*
        todo This has been disabled but I've left it in place for future reference in case I need
             to set up another subscriber
        // Not all mutations should reload the view. For example, doing it for onMetaClick would cause the view to
        // refresh everytime the user selected an item.
        let permittedViewMutations = [
            'onMetaClick',
            'onShiftClick',
            'selectAll',
            'setGroupLoadedCategoryData',
        ]
        if (
            mutation.type.indexOf('view:') === 0
            && permittedViewMutations.indexOf(mutation.type.split('/').pop()) === -1
        ) {
            //console.log('mutation', mutation.type);
            
            let m = mutation.type.split('/')[0]
            //if (store.hasModule(m)) {
            store.dispatch(m + '/scheduleLoad')
            //}
        }
        //*/
        
        // called after every mutation.
        // The mutation comes in the format of `{ type, payload }`.
    })
};